var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _rect13, _rect14, _circle;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWatercolors = function SvgWatercolors(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M537 137.69a3.64 3.64 0 0 0 3.51-3.78 3.57 3.57 0 0 0-3.51-3.51c-3.24 0-32.4-1.08-32.4-35.09a3.51 3.51 0 1 0-7 0c0 34-29.16 35.09-32.4 35.09h-.27a3.52 3.52 0 0 0-3.24 3.51 3.57 3.57 0 0 0 3.51 3.51c3.51 0 32.4 1.08 32.4 35.1A3.57 3.57 0 0 0 501 176c1.62.27 3.24-1.35 3.24-3.24 0-34 29.16-35.1 32.4-35.1z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 176.66,
    y: 62.52,
    width: 263.54,
    height: 472.88,
    rx: 14,
    transform: "rotate(-14.49 308.462 298.955)",
    fill: "#fdb73e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 298.95,
    y: 90.14,
    width: 21.56,
    height: 411.26,
    rx: 5.25,
    transform: "rotate(-14.49 309.742 295.8)",
    fill: "#d6842d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 172.59,
    y: 119.33,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 205.391 152.124)",
    fill: "#f4abe0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 193.85,
    y: 201.56,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 226.63 234.357)",
    fill: "#ef6ba0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 215.1,
    y: 283.8,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 247.87 316.59)",
    fill: "#f0592b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 236.35,
    y: 366.04,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 269.148 398.828)",
    fill: "#93b847"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 257.61,
    y: 448.27,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 290.387 481.061)",
    fill: "#015e85"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 299.36,
    y: 86.57,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 332.133 119.358)",
    fill: "#16a99e"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 320.61,
    y: 168.8,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 353.412 201.596)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 341.87,
    y: 251.04,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 374.65 283.829)",
    fill: "#d6842d"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 363.12,
    y: 333.27,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 395.93 366.067)",
    fill: "#6e5f91"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 384.37,
    y: 415.51,
    width: 65.54,
    height: 65.54,
    rx: 2,
    transform: "rotate(-14.49 417.169 448.3)",
    fill: "#6ab4e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.61 266.69l-.35-.1c-1.85-.64-2.64-2.77-3.2-4.65-1.64-5.55-3.29-11.11-4.41-16.78s-1.73-11.88-3.94-17.42-6.1-10.75-8.89-16.18c-6-11.76-10.29-24.39-11.18-37.64a21.36 21.36 0 0 1 .4-3.87c11.36-2.46 22.73-4.84 34-7.5a8.1 8.1 0 0 1 3.58-.3c3.39.75 4.29 5.06 4.73 8.51 1 7.64 3 15.1 3.93 22.74s-.58 14.06-1.49 21.5c-1.84 15 4.52 29.79 7.49 44.24.22 1.09.41 2.35-.29 3.22a3.79 3.79 0 0 1-2.15 1.06q-7.78 1.91-15.72 3.11a6.85 6.85 0 0 1-2.51.06z",
    fill: "#dbd9d8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 57.36,
    y: 111.62,
    width: 44.66,
    height: 57.11,
    rx: 2,
    transform: "rotate(-11.79 79.647 140.121)",
    fill: "#015e85"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 130.1,
    y: 256.69,
    width: 24.47,
    height: 325.64,
    rx: 1,
    transform: "rotate(-12.91 142.392 419.61)",
    fill: "#f0592b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 562.65,
    cy: 399.69,
    r: 7.72,
    fill: "#6e5f91"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatercolors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watercolors.abc31cee.svg";
export { ForwardRef as ReactComponent };